export const formatterCurrency = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL"
});

/**
 * Gets value from element and returns as formatted currency string.
 *
 * @param {HTMLInputElement} element to get the value from
 * @returns {string} formatted currency value
 */
export const getFormattedCurrencyValueFromEl = (element) => {
  if (!("value" in element) || !element.value || element.value?.trim().length < 1) {
    return 0;
  }
  return formatterCurrency.format(element.value / 100);
};

/**
 * Remove non-currency related characters from string for getting number without decimals separator
 *
 * @param {string} value formatted
 * @returns {string} numeric value without decimals (value * 100)
 */
export const getValueWithoutFormat = function (value) {
  return value.replace(/[^0-9,.]+/gm, "").replace(",", ".").replace(".", "");
};

/**
 * Gets input element value in lowercase
 *
 * @param {HTMLInputElement} element input field to get value from
 * @returns {string} input element field in lowercase
 */
export const getLowerCaseInputValue = function (element) {
  return element.value.toString().toLowerCase();
};
